export const eur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n || 0));

export const num = (n) => new Intl.NumberFormat("it-IT").format(Number(n || 0));

// Timezone del salone: tutte le date/ore sono mostrate in Europe/Rome,
// indipendentemente dal fuso del browser (coerenza con backend).
const SALON_TZ = "Europe/Rome";

export const fmtDate = (d, opts) => {
  if (!d) return "\u2014";
  try {
    return new Date(d).toLocaleDateString("it-IT", { timeZone: SALON_TZ, ...(opts || { day: "2-digit", month: "short", year: "numeric" }) });
  } catch { return "\u2014"; }
};

export const fmtTime = (d) => {
  if (!d) return "\u2014";
  return new Date(d).toLocaleTimeString("it-IT", { timeZone: SALON_TZ, hour: "2-digit", minute: "2-digit" });
};

export const fmtDateTime = (d) => `${fmtDate(d)} ${fmtTime(d)}`;

// Minuti dalla mezzanotte in Europe/Rome (per posizionare i blocchi in Agenda
// senza dipendere dal fuso del browser).
export const romeMinutes = (d) => {
  try {
    const parts = new Intl.DateTimeFormat("en-GB", { timeZone: SALON_TZ, hour: "2-digit", minute: "2-digit", hour12: false }).formatToParts(new Date(d));
    const h = Number(parts.find((p) => p.type === "hour")?.value || 0);
    const m = Number(parts.find((p) => p.type === "minute")?.value || 0);
    return h * 60 + m;
  } catch { return 0; }
};

// Chiave giorno (YYYY-MM-DD) calcolata in Europe/Rome.
export const romeDayKey = (d) => {
  try {
    return new Intl.DateTimeFormat("en-CA", { timeZone: SALON_TZ, year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(d));
  } catch { return ""; }
};

export const initials = (name = "") =>
  name.split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();
